<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.white
        v-row(no-gutters)
            p.mb-0.h6.basic800--text Receipt {{ displayReceiptId }}

      v-card-text.pa-0.text-center
        v-container.pt-6(:style="$vuetify.breakpoint.xsOnly? 'min-height:100vh' : ''")
          //- Loading state
          div.my-6(v-if="isFetching")
            v-row.ma-0(style="height:60vh" align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          template(v-else)
            .paid-amount
              eva-icon.my-5(name="checkmark-circle-2-outline" :fill="$vuetify.theme.themes[$theme].success" width="50" height="50")
              p.s1.mb-0.primary500--text Amount paid
              div.h4.primary500--text.text-center {{ item.amount | displayPrice }}
              .s1.primary400--text.text-center {{ item.created | convertServerDate }}
              .c1.primary400--text.text-center {{ paymentDescription }}
              v-divider.my-6
            .company-details.text-left.mt-4.px-2
              v-layout
                div.h6.s1.primary500--text Yezza Tech Sdn Bhd
              div.p2.primary500--text 03-8687 4950
              .address
                div.p2.primary500--text K-3-01, Conezion, Persiaran IRC3,
                div.p2.primary500--text IOI Resort City, Putrajaya,
                div.p2.primary500--text 62502, Wilayah Persekutuan Putrajaya, Malaysia.

            .client-details.text-left.mt-8.px-2
              div.p1.primary500--text Bill to:
              div.s1.primary500--text {{ company.name }}
              div.p2.primary500--text {{ company.phone }}
              .address(v-if="company.address")
                div.p2.primary500--text {{ company.address.address_1 }},
                div.p2.primary500--text(v-if="company.address.address_2") {{ company.address.address_2 }},
                template(v-if="company.address.area")
                  div.p2.primary500--text {{ company.address.postcode }} {{ company.address.area }},
                  div.p2.primary500--text {{ company.address.suburb }}, {{ company.address.city }},
                div.p2.primary500--text(v-else) {{ company.address.postcode }} {{ company.address.city }},
                div.p2.primary500--text {{ company.address.state }}, {{ company.address.country }}.
              v-divider.my-6
            v-row.mt-0.mb-3.ml-2.mr-2
              v-col.text-left.pa-0
                p.mb-1.s1.primary400--text Description
              v-col.text-right.pa-0
                p.mb-1.s1.primary400--text Amount
            //- Shipping description
            template(v-if="item.type === 'Shipping'")
              v-row.mt-0.mb-0.ml-2.mr-2.pa-0(v-for="shipping in shippingData" :key="shipping.id")
                v-col.text-left.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ getShippingDescription(shipping) }}
                    v-chip.white--text.ml-2(v-if="shipping.refund" x-small color="success500") refund
                v-col.text-right.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ getShippingFee(shipping) | displayPrice($currency) }}
            //- Shipping adjustment description
            template(v-else-if="item.type === 'Shipping Adjustment'")
              v-row.mt-0.mb-0.ml-2.mr-2.pa-0
                v-col.text-left.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2(v-html="getAdjustmentDescription()")
                v-col.text-right.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ item.amount | displayPrice($currency) }}
            //- Other description
            template(v-else)
              v-row.mt-0.mb-0.ml-2.mr-2.pa-0
                v-col.text-left.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ item.title }}
                v-col.text-right.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ item.amount | displayPrice($currency) }}
                  
            hr.my-5(style="border: 1px dashed #848484; width:100%;")

            v-col.ma-0.pa-0.px-0
              v-row.mt-0.mb-1.ml-2.mr-2
                v-col.text-left.pa-0
                  p.mb-1.p1.primary400--text Subtotal:
                v-col.text-right.pa-0
                  p.mb-1.p1.primary400--text {{ item.amount | displayPrice($currency) }}
              v-row.mt-0.mb-1.ml-2.mr-2
                v-col.text-left.pa-0
                  p.mb-1.p1.primary400--text Tax:
                v-col.text-right.pa-0
                  p.mb-1.p1.primary400--text 0%
              v-row.mt-0.mb-1.ml-2.mr-2
                v-col.text-left.pa-0
                  p.mb-1.h6.primary--text Total:
                v-col.text-right.pa-0
                  p.mb-1.h6.primary--text {{ item.amount | displayPrice($currency) }}

            div.text-center.mb-12
              div.label.f1.mb-0.mt-10.primary400--text {{ $t('powered_by_yezza') }}
              div.label.f2.mb-0.mt-0.primary400--text(style="margin-left:2px; font-weight:400;") This is computer generated document. No signature required.
      v-card-actions
        v-spacer
        v-btn.button-Aa-medium(color='info500', text @click='showModal = false')
          | Close
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

export default {
  name: 'CreditHistoryReceipt',
  props: {
    open: {
      type: Boolean
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFetching: false,
      shippingData: null
    }
  },
  mounted() {
    if (this.item.type === 'Shipping') {
      this.fetchAllYezzaShippings()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    displayReceiptId() {
      return `#${DateTime.fromISO(this.item.created).toFormat('yyMMdd')}-${this.item.ref}`
    },
    paymentDescription() {
      let commonDescription = 'Paid via '
      switch (this.item.payment_method) {
        case 'Wallet':
          commonDescription += 'wallet'
          break

        case 'Credit Card':
          commonDescription += `card ending *${this.item.payment_source.match(/[0-9]+/)} (${this.item.payment_ref
            .split(':')
            .slice(0, 2)
            .join(':')})`
          break

        case 'FPX':
          commonDescription += `FPX (${this.item.payment_ref})`
          break

        default:
          commonDescription = null
          break
      }
      return commonDescription
    }
  },
  methods: {
    async fetchAllYezzaShippings() {
      try {
        this.isFetching = true
        const allFetching = this.item.data.ys_fulfilment.ys_id.map((id, index) => this.fetchYezzaShipping(id, index))
        this.shippingData = await Promise.all([...allFetching])
        this.isFetching = false
      } catch (error) {
        this.showMessage(['error', 'Unable to complete your request. Please try again later'])
      }
    },
    fetchYezzaShipping(id, index) {
      const allowedProperties = ['id', 'fee', 'fulfilment', 'name', 'receipt_no', 'weight']
      return this.$axios.get(`/shipping/yezzashipping/${id}`).then(res => {
        const filteredObj = this.$options.filters.filterAllowedObjectProperties(res.data, allowedProperties)
        const orderNo = this.item.data.ys_fulfilment.order_no[index]
        let refund = false
        if (this.item.data.ys_refund) {
          const index = this.item.data.ys_refund.findIndex(refund => refund.ys_id === id)
          if (index >= 0) {
            refund = this.item.data.ys_refund[index]
          }
        }
        return { ...filteredObj, orderNo, refund }
      })
    },
    getShippingDescription(shipping) {
      // Refund data
      if (shipping.refund) {
        return `${shipping.refund.meta_data.shipping_name.includes('Lalamove') ? 'Lalamove' : shipping.refund.meta_data.shipping_name} ${shipping.refund.meta_data.service_type} ${shipping.refund.weight ?? shipping.weight}kg (#${shipping.orderNo})`
      }
      // Auto cancel without refund object
      if (shipping.receipt_no !== this.item.data.ys_fulfilment.receipt_no) {
        return 'No data'
      }
      // Normal data
      return `${shipping.fulfilment.title.includes('Lalamove') ? 'Lalamove' : shipping.fulfilment.title} ${shipping.fulfilment.meta_data.service_type} ${shipping.weight}kg (#${shipping.orderNo})`
    },
    getShippingFee(shipping) {
      // Refund data
      if (shipping.refund) {
        if (this.item.title.includes('single')) {
          return this.item.amount
        }
        return shipping.refund.fee ?? shipping.fee
      }
      // Auto cancel without refund object
      if (shipping.receipt_no !== this.item.data.ys_fulfilment.receipt_no) {
        if (this.item.title.includes('single')) {
          return this.item.amount
        }
        return shipping.fee
      }
      // Normal data
      return shipping.fee
    },
    getAdjustmentDescription() {
      const adjustment = this.item.data.ys_adjustment
      return `Weight discrepancy (#${adjustment.lead_rid})
      <br />
      Submitted : ${adjustment.weight}
      <br />
      Actual : ${adjustment.actual_weight}`
    }
  }
}
</script>

<style scoped>
</style>